import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetomahabaleshwarhire() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Mahabaleshwar Hire',
        heading: 'Urbania on rent in pune: Urbania for Pune to Mahabaleshwar Hire',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania for Pune to Mahabaleshwar Hire services for families, tourists, corporate groups, and event travelers planning trips to the scenic hill station of Mahabaleshwar. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for weekend getaways, sightseeing tours, corporate outings, and group travel from Pune to Mahabaleshwar. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free journey. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Urbania on rent in pune',


      "topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a serene artificial lake in Mahabaleshwar, surrounded by lush greenery and offering boating facilities. Visitors can enjoy paddle boats, rowboats, or simply stroll along the promenade. The area is dotted with food stalls selling local snacks like corn on the cob and strawberries. Evenings here are particularly picturesque with the reflection of the surrounding hills on the water, making it a favorite spot for families and couples."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is one of the most famous viewpoints in Mahabaleshwar, offering breathtaking panoramic views of the dense valleys, hills, and the Savitri River. Known as the 'Queen of all points,' it is ideal for photography, trekking, and watching sunsets. The spot is steeped in legend and provides a spectacular vantage point for nature lovers."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a popular tourist attraction known for its strawberry farms, jam production, and confectionery products. Visitors can stroll through the lush gardens, sample fresh strawberries, and purchase jams, chocolates, and other local delicacies. The garden also has a cafe serving refreshing drinks and snacks, making it a delightful stop for families and food enthusiasts."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a natural rock formation resembling an elephant’s head, offering stunning views of the surrounding valleys and rivers. The spot is popular for photography, adventure enthusiasts, and tourists looking for a peaceful connection with nature. The landscape is especially beautiful during the monsoon season."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, located near Mahabaleshwar, is a historic fort built by Chhatrapati Shivaji Maharaj. It played a crucial role in Maratha history and offers panoramic views of the Western Ghats. Visitors can explore the fortifications, temples, and the scenic surroundings, making it an enriching combination of history and nature."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a picturesque waterfall cascading amidst lush greenery and steep cliffs. The area around the waterfall is ideal for trekking, picnics, and photography. During the monsoon, the waterfall is at its most spectacular, attracting nature lovers and adventure enthusiasts alike."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak is the second highest point in Mahabaleshwar, offering panoramic views of the Sahyadri ranges. Ideal for trekking, photography, and sunrise/sunset views, the peak attracts adventure seekers and nature lovers looking for a serene escape amidst the hills."
  },
  {
    "title": "Kate’s Point",
    "description": "Kate’s Point is a scenic viewpoint near Mahabaleshwar overlooking the Krishna Valley and Dhom Dam. The spot is popular for photography, family outings, and enjoying the lush landscapes of the Western Ghats. The surrounding area has local fruit vendors selling fresh strawberries and other produce."
  },
  {
    "title": "Bombay Point (Sunrise Point)",
    "description": "Bombay Point, also known as Sunrise Point, offers mesmerizing views of the sun rising over the hills and valleys. The panoramic vistas make it one of the best spots for photography, morning walks, and enjoying the tranquil beauty of Mahabaleshwar’s hill station charm."
  },
  {
    "title": "Panchgani Table Land",
    "description": "Located a short drive from Mahabaleshwar, Panchgani Table Land is the second longest mountain plateau in Asia. It offers breathtaking views, horse riding opportunities, and trekking trails. Tourists often combine visits to Mahabaleshwar and Panchgani for a complete hill station experience filled with natural beauty and adventure activities."
  }
],



"services": [
    {
      "name": "Urbania for Pune to Mahabaleshwar Hire",
      "description": "Urbania for Pune to Mahabaleshwar Hire provides comfortable, reliable vehicles for long-distance travel to the hill station. Ideal for families, friends, and group outings, the service ensures spacious seating, professional chauffeurs, ample luggage space, and a safe, stress-free journey to Mahabaleshwar with scenic route experience."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Rental",
      "description": "Pune to Mahabaleshwar Urbania Rental offers dependable and convenient intercity transportation. Perfect for leisure trips, weekend getaways, and corporate retreats, the service focuses on vehicle cleanliness, driver professionalism, and smooth travel to ensure travelers enjoy a comfortable ride through Pune’s highways to the hill station."
    },
    {
      "name": "Urbania Bus Rental Pune to Mahabaleshwar",
      "description": "Urbania Bus Rental Pune to Mahabaleshwar provides spacious buses for group travel, corporate tours, and family trips. Equipped with safety features, ample seating, and professional drivers, these buses ensure a comfortable and organized journey, making long-distance travel to Mahabaleshwar easy and enjoyable."
    },
    {
      "name": "Urbania AC Bus Pune to Mahabaleshwar",
      "description": "Urbania AC Bus Pune to Mahabaleshwar offers fully air-conditioned buses for a comfortable hill station journey. Ideal for corporate groups, families, and tourists, these buses come with climate control, spacious seating, luggage space, and experienced chauffeurs to make the ride smooth and relaxing."
    },
    {
      "name": "Pune Mahabaleshwar Urbania One Way Hire",
      "description": "Pune Mahabaleshwar Urbania One Way Hire provides flexible one-way travel options for individuals, families, and corporate teams. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, offering a hassle-free travel experience from Pune to Mahabaleshwar for short trips or leisure visits."
    },
    {
      "name": "Pune Mahabaleshwar Urbania Round Trip Hire",
      "description": "Pune Mahabaleshwar Urbania Round Trip Hire delivers reliable and convenient round-trip solutions for tourists, families, and corporate travelers. With punctual service, comfortable seating, and professional drivers, this service ensures a smooth and enjoyable journey to Mahabaleshwar and back to Pune without any stress."
    },
    {
      "name": "Corporate Urbania Pune to Mahabaleshwar",
      "description": "Corporate Urbania Pune to Mahabaleshwar offers professional transportation solutions for business trips, corporate retreats, and conferences. Vehicles are equipped for executive comfort, with trained chauffeurs, timely service, and clean interiors, ensuring a seamless travel experience for corporate teams heading to Mahabaleshwar."
    },
    {
      "name": "Family Tour Urbania Pune to Mahabaleshwar",
      "description": "Family Tour Urbania Pune to Mahabaleshwar provides safe, spacious, and comfortable vehicles for family trips and group outings. With courteous drivers, ample luggage space, and well-maintained interiors, families can enjoy a stress-free journey and focus on sightseeing and leisure activities at the hill station."
    },
    {
      "name": "Luxury Urbania Pune to Mahabaleshwar",
      "description": "Luxury Urbania Pune to Mahabaleshwar offers high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. With professional chauffeurs, smooth rides, and attention to detail, this service ensures a luxurious travel experience to the scenic hill station."
    },
    {
      "name": "Affordable Urbania Pune to Mahabaleshwar",
      "description": "Affordable Urbania Pune to Mahabaleshwar delivers cost-effective transportation for families, groups, and budget-conscious travelers. Vehicles are well-maintained, safe, and driven by professional chauffeurs, ensuring comfortable and reliable long-distance travel without compromising on quality."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Mahabaleshwar",
      "description": "Chauffeur Driven Urbania Pune to Mahabaleshwar provides stress-free travel with experienced and verified drivers. Vehicles are spacious, well-maintained, and suitable for long-distance journeys, making it ideal for families, groups, and corporate travelers seeking convenience, safety, and a comfortable ride to the hill station."
    },
    {
      "name": "Pune Mahabaleshwar Urbania Travel Service",
      "description": "Pune Mahabaleshwar Urbania Travel Service offers end-to-end transportation solutions for trips to the hill station. From reliable vehicles and trained chauffeurs to punctual service and luggage handling, this service ensures a seamless, comfortable, and enjoyable journey for leisure, corporate, and family travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Mahabaleshwar",
      "description": "Best Urbania Hire Pune to Mahabaleshwar delivers top-rated intercity transportation services with a focus on comfort, reliability, and customer satisfaction. Ideal for families, corporate teams, and group travelers, it ensures smooth, safe, and timely travel from Pune to Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Booking",
      "description": "Pune to Mahabaleshwar Urbania Booking enables easy and convenient reservation of Urbania vehicles for one-way or round-trip travel. Travelers can select from multiple vehicle types to ensure a comfortable, safe, and hassle-free journey to Mahabaleshwar, with professional chauffeur services included."
    },
    {
      "name": "Urbania Hill Station Tour Pune",
      "description": "Urbania Hill Station Tour Pune specializes in transportation for scenic trips and leisure tours to hill stations like Mahabaleshwar. With comfortable vehicles, professional drivers, and ample space for passengers and luggage, the service ensures a relaxing, stress-free journey while allowing travelers to enjoy the picturesque landscapes en route."
    }
  ],
  "tableData": [
    ["Urbania for Pune to Mahabaleshwar Hire", "Pune to Mahabaleshwar Urbania Rental"],
    ["Urbania Bus Rental Pune to Mahabaleshwar", "Urbania AC Bus Pune to Mahabaleshwar"],
    ["Pune Mahabaleshwar Urbania One Way Hire", "Pune Mahabaleshwar Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Mahabaleshwar", "Family Tour Urbania Pune to Mahabaleshwar"],
    ["Luxury Urbania Pune to Mahabaleshwar", "Affordable Urbania Pune to Mahabaleshwar"],
    ["Chauffeur Driven Urbania Pune to Mahabaleshwar", "Pune Mahabaleshwar Urbania Travel Service"],
    ["Best Urbania Hire Pune to Mahabaleshwar", "Pune to Mahabaleshwar Urbania Booking"],
    ["Urbania Hill Station Tour Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Mahabaleshwar Hire",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire is perfect for comfortable and spacious group travel, ideal for family trips, corporate travel, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire comes with skilled drivers familiar with Pune-Mahabaleshwar routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Mahabaleshwar Hire for competitive rates with no hidden charges, making outstation group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Mahabaleshwar trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Mahabaleshwar Hire guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Mahabaleshwar Hire available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Mahabaleshwar Hire can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Mahabaleshwar Hire?',
        answer: 'You can book Urbania for Pune to Mahabaleshwar Hire via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Mahabaleshwar Hire for group travel?',
        answer: 'Urbania for Pune to Mahabaleshwar Hire provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Mahabaleshwar Hire suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Mahabaleshwar.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Mahabaleshwar Hire?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Mahabaleshwar Hire?',
        answer: 'Absolutely. Urbania for Pune to Mahabaleshwar Hire allows flexible pickup and drop-off across Pune and Mahabaleshwar.',
    },
    {
        question: 'Is Urbania for Pune to Mahabaleshwar Hire available 24x7?',
        answer: 'Yes, Urbania for Pune to Mahabaleshwar Hire operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Mahabaleshwar Hire?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Mahabaleshwar Hire?',
        answer: 'Urbania for Pune to Mahabaleshwar Hire accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Deshpande',
        feedback: 'We booked Urbania for Pune to Mahabaleshwar Hire for a family outing. The vehicle was spacious, clean, and very comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Patil',
        feedback: 'Urbania for Pune to Mahabaleshwar Hire provided great service for our corporate trip. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];



























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Mahabaleshwar Hire",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-mahabaleshwar.jpg",
  "description": "Urbania for Pune to Mahabaleshwar Hire provides AC and non-AC Urbania bus rental services for one-way and round-trip travel. Ideal for family tours, corporate trips, luxury travel, and hill station tours. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys from Pune to Mahabaleshwar.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "980",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-mahabaleshwar-hire"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Mahabaleshwar Hire | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Mahabaleshwar Hire for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and hill station tours. Chauffeur-driven service for safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Mahabaleshwar Hire, Pune to Mahabaleshwar Urbania Rental, Urbania Bus Rental Pune to Mahabaleshwar, Urbania AC Bus Pune to Mahabaleshwar, Pune Mahabaleshwar Urbania One Way Hire, Pune Mahabaleshwar Urbania Round Trip Hire, Corporate Urbania Pune to Mahabaleshwar, Family Tour Urbania Pune to Mahabaleshwar, Luxury Urbania Pune to Mahabaleshwar, Affordable Urbania Pune to Mahabaleshwar, Chauffeur Driven Urbania Pune to Mahabaleshwar, Pune Mahabaleshwar Urbania Travel Service, Best Urbania Hire Pune to Mahabaleshwar, Pune to Mahabaleshwar Urbania Booking, Urbania Hill Station Tour Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetomahabaleshwarhire;